module.exports = __webpack_public_path__ + "img/icon-monkey.66d3b09b.svg";